module.exports = __webpack_public_path__ + "img/img_slide_4.ea6d82c3.webp";